'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = syncComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function syncComponent(chunkName, mod) {
  var Component = mod.default ? mod.default : mod;

  function SyncComponent(props) {
    if (props.staticContext && props.staticContext.splitPoints) {
      props.staticContext.splitPoints.push(chunkName);
    }

    return _react2.default.createElement(Component, props);
  }

  SyncComponent.propTypes = {
    staticContext: _propTypes2.default.object
  };

  SyncComponent.fetchData = Component.fetchData || null;

  SyncComponent.fetchIntl = Component.fetchIntl || null;

  return SyncComponent;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/utils/syncComponent.js
// module id = 0B8B
// module chunks = 4